import { useEffect, useState } from "react";
import { isAppEntryLoadError, reloadAppEntry } from "../../utils/loadAppEntry";

// Keep this independent of MUI and the application bundle that failed to load.
export default function AppEntryErrorFallback({ error }) {
  const [offline, setOffline] = useState(navigator.onLine === false);
  useEffect(() => {
    const updateConnection = () => setOffline(navigator.onLine === false);
    window.addEventListener("online", updateConnection);
    window.addEventListener("offline", updateConnection);
    return () => {
      window.removeEventListener("online", updateConnection);
      window.removeEventListener("offline", updateConnection);
    };
  }, []);

  return (
    <main
      aria-labelledby="app-load-error-title"
      style={{ maxWidth: 560, margin: "10vh auto", padding: "2rem", fontFamily: "system-ui, sans-serif", color: "#172b4d", lineHeight: 1.6 }}
    >
      <h1 id="app-load-error-title" style={{ fontSize: "1.75rem", lineHeight: 1.3 }}>
        {isAppEntryLoadError(error)
          ? "We couldn’t load Maps and Pathways"
          : "Something went wrong"}
      </h1>
      <p role="status">
        {offline
          ? "You appear to be offline. Reconnect, then reload this page to try again."
          : "Check your connection, then reload this page to try again."}
      </p>
      <button
        type="button"
        onClick={() => reloadAppEntry()}
        style={{ minHeight: 44, padding: "0.65rem 1.25rem", font: "inherit", cursor: "pointer", background: "#174b80", color: "#fff", border: "1px solid #174b80", borderRadius: 6 }}
      >
        Reload page
      </button>
      <p>If it still won’t load, <a href="mailto:hello@mapsandpathways.com" style={{ textDecoration: "underline" }}>contact support</a>.</p>
    </main>
  );
}
